var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuUnfold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 35,
    viewBox: "0 0 41 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2124_5460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2.47754C0.25 1.37297 1.14543 0.477539 2.25 0.477539H38.25C39.3546 0.477539 40.25 1.37297 40.25 2.47754V30.4775C40.25 31.5821 39.3546 32.4775 38.25 32.4775H2.25C1.14543 32.4775 0.25 31.5821 0.25 30.4775V2.47754Z",
    fill: "#1890FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0.977539H38.25C39.0784 0.977539 39.75 1.64911 39.75 2.47754V30.4775C39.75 31.306 39.0784 31.9775 38.25 31.9775H2.25C1.42157 31.9775 0.75 31.306 0.75 30.4775V2.47754C0.75 1.64911 1.42157 0.977539 2.25 0.977539Z",
    stroke: "#1890FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2124_5460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.594 15.488H11.9057C11.7985 15.488 11.7108 15.4003 11.7108 15.2932V13.9295C11.7108 13.8224 11.7985 13.7347 11.9057 13.7347H23.594C23.7011 13.7347 23.7888 13.8224 23.7888 13.9295V15.2932C23.7888 15.4003 23.7011 15.488 23.594 15.488ZM23.7888 20.4555C23.7888 20.5627 23.7011 20.6503 23.594 20.6503H11.9057C11.7985 20.6503 11.7108 20.5627 11.7108 20.4555V19.0919C11.7108 18.9847 11.7985 18.8971 11.9057 18.8971H23.594C23.7011 18.8971 23.7888 18.9847 23.7888 19.0919V20.4555ZM11.516 8.62109H30.607C30.7141 8.62109 30.8018 8.70876 30.8018 8.8159V10.1795C30.8018 10.2867 30.7141 10.3743 30.607 10.3743H11.516C11.4089 10.3743 11.3212 10.2867 11.3212 10.1795V8.8159C11.3212 8.70876 11.4089 8.62109 11.516 8.62109ZM11.516 24.0107H30.607C30.7141 24.0107 30.8018 24.0984 30.8018 24.2055V25.5691C30.8018 25.6763 30.7141 25.764 30.607 25.764H11.516C11.4089 25.764 11.3212 25.6763 11.3212 25.5691V24.2055C11.3212 24.0984 11.4089 24.0107 11.516 24.0107ZM30.719 17.3605L26.913 20.3581C26.7717 20.4701 26.5623 20.3703 26.5623 20.1901V14.195C26.5623 14.0148 26.7693 13.9149 26.913 14.0269L30.719 17.0245C30.7446 17.0444 30.7653 17.0699 30.7795 17.099C30.7938 17.1281 30.8012 17.1601 30.8012 17.1925C30.8012 17.2249 30.7938 17.2569 30.7795 17.286C30.7653 17.3152 30.7446 17.3406 30.719 17.3605Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2124_5460",
    x: 0.25,
    y: 0.477539,
    width: 40,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.043 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2124_5460"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2124_5460",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2124_5460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10.25 6.47754)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUnfold);
export default __webpack_public_path__ + "static/media/menuUnfold.3afec60c0ad6783e196a8af66a0bb2d5.svg";
export { ForwardRef as ReactComponent };